import React, {useEffect, useState} from 'react';
import {Col, Row, Spin, Tabs, TabsProps} from "antd";
import {FormattedMessage} from "react-intl";
import {Navigate} from "react-router-dom";
import {isMobileOnly} from "react-device-detect";
import '../assets/css/Dentobook.css';
import DetailWrapper from "../components/common/DetailWrapper";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";
import SubscriptionPlan from "../components/subscription/SubscriptionPlan";
import StripeInvoices from "../components/subscription/StripeInvoices";
import {getStripeApi} from "../api/apiInstances";
import logger from "../utils/logger";

const BillingPage = () => {
    const [stripeEnabled, setStripeEnabled] = useState<boolean | null>(null);

    useEffect(() => {
        getStripeApi().isStripeEnabled()
            .then(res => setStripeEnabled(res.data?.enabled ?? false))
            .catch(err => {
                logger.error('Failed to check Stripe status:', err);
                setStripeEnabled(false);
            });
    }, []);

    if (stripeEnabled === null) {
        return <Spin/>;
    }

    if (!stripeEnabled) {
        return <Navigate to="/" replace/>;
    }

    const items: TabsProps['items'] = [
        {
            label: <FormattedMessage id="subscription"/>,
            key: 'subscription',
            children: <SubscriptionPlan/>
        },
        {
            label: <FormattedMessage id="invoices"/>,
            key: 'stripe-invoices',
            children: <StripeInvoices/>
        },
    ];

    return (
        <AccessControl accessibleFor={[accessibilityRoles.CLINIC_ADMIN]}>
            <DetailWrapper>
                <Row className="mb-2">
                    <Col span={12}>
                        <h3><FormattedMessage id="billing"/></h3>
                    </Col>
                </Row>
                <Tabs key="billing-tabs" items={items}/>
                {isMobileOnly ? <div style={{marginBottom: 150}}/> : null}
            </DetailWrapper>
        </AccessControl>
    );
};

export default BillingPage;
